module.exports = __webpack_public_path__ + "img/emssolution-app.7a0ee640.jpg";